import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { Activite } from './activite.entity';
import { Produit } from './produit.entity';

@Entity('activite_produit')
export default class ActiviteProduit {
    static non_privileged_properties: (keyof ActiviteProduit)[] = [];
    static regular_privileged_properties: (keyof ActiviteProduit)[] = ['activite', 'produit'];
    static admin_privileged_properties: (keyof ActiviteProduit)[] = [];

    @PrimaryGeneratedColumn()
    id: number;

    @Column({ type: 'integer', nullable: true })
    fk_id_activite: number;

    @ManyToOne(() => Activite, (activite) => activite.activiteProduits)
    @JoinColumn({ name: 'fk_id_activite' })
    activite: Activite;

    @Column()
    fk_id_produit: number;

    @ManyToOne(() => Produit, (produit) => produit.activiteProduits)
    @JoinColumn({ name: 'fk_id_produit' })
    produit: Produit;

    @Column({ type: 'integer', nullable: true })
    priorite: number | '';
}
